
import Message2 from "../../../assets/duotone/Message2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Message2Icon({ className, dataTestid = "Message2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Message2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
